import BottomSheet from '@components/BottomSheet'
import EmptyList from '@components/EmptyList'
import { SidebarMobileToggle } from '@components/Sidebar/MobileToggle'
import { useEarnPositions } from '@plug-core/hooks/earn/useEarnPositions'
import { EarnPosition } from '@plug-core/interfaces/earn'
import { Button, Heading, ListGroup, Spinner, cn } from '@ui'
import { ROUTES } from '@utils/routes'
import { getWindowDimensions } from '@utils/windows'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { PositionDetails } from './Components/PositionDetails'
import { PositionListItem } from './Components/PositionListItem'

export const Earn = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [displayedPosition, setDisplayedPosition] = useState<EarnPosition>()

  const { positions, loading: positionsLoading } = useEarnPositions()
  console.log({ positions })
  return (
    <div
      className="flex flex-col gap-3 overflow-hidden"
      style={{ height: getWindowDimensions().height - 48 }}
    >
      <SidebarMobileToggle title={t('earn.title')} />

      <div
        className={cn(
          'flex min-h-0 flex-1 flex-col',
          displayedPosition ? 'overflow-y-hidden' : 'overflow-y-auto'
        )}
      >
        <Heading level={4} align="center" className="mb-4">
          {t('earn.openPositions')}
        </Heading>

        {!positionsLoading && positions?.length === 0 && (
          <div className="mt-20 flex flex-col">
            <EmptyList
              emoji="🌱"
              title={t('earn.noPositions')}
              description={t('earn.noPositionsDescription')}
            />
          </div>
        )}

        {positions?.length > 0 && (
          <ListGroup>
            {positions.map((position, i) => (
              <PositionListItem
                key={`${position.chainId}-${position.asset.address}-${i}`}
                position={position}
                onClick={setDisplayedPosition}
              />
            ))}
          </ListGroup>
        )}

        {positionsLoading && (
          <div className="flex flex-col items-center py-4 text-fg-2">
            <Spinner size={20} />
          </div>
        )}

        {!positionsLoading && (
          <div className="mt-2 flex justify-center">
            <Button onClick={() => navigate(ROUTES.EARN_VAULTS)} size="sm" variant="ghost">
              {t('earn.openNew')}
            </Button>
          </div>
        )}
      </div>

      {displayedPosition && (
        <BottomSheet visible onBackdropClick={() => setDisplayedPosition(undefined)}>
          <PositionDetails
            position={displayedPosition}
            onClose={() => setDisplayedPosition(undefined)}
          />
        </BottomSheet>
      )}
    </div>
  )
}

export default Earn
